export const URL =
	String(window.location.href).indexOf('localhost') > -1
		? 'http://localhost:5000/somity/api/v1'
		: `${process.env.REACT_APP_API_URL}`;

export const SOCKETURL =
	String(window.location.href).indexOf('localhost') > -1
		? 'http://localhost:5000/somity'
		: `${process.env.REACT_APP_API_URL}`;
